export const OrderItemOriginalPriceAddonsFragment = /* GraphQL */ `
	fragment OrderItemOriginalPriceAddonsFragment on OriginalPriceAddons {
		vat {
			percentage
			amount
		}
		service_charge {
			percentage
			amount
		}
		service_charge_bd {
			percentage
			amount
		}
	}
`;

export const OrderItemOptionOriginalPriceAddonsFragment = /* GraphQL */ `
	fragment OrderItemOptionOriginalPriceAddonsFragment on OriginalPriceAddons {
		vat {
			percentage
			amount
		}
		service_charge {
			percentage
			amount
		}
		service_charge_bd {
			percentage
			amount
		}
	}
`;
